import { Injectable } from '@angular/core';
import { Response, ResponseContentType, RequestOptions, URLSearchParams } from '@angular/http';

import { AuthHttp, QueryEncoderHelper } from '../../../common/index';
import { AppSettings } from '../../../settings/index';

@Injectable()
export class TimeSlotService {
    constructor(private http: AuthHttp) { }

    get() {
        return this.http.get(AppSettings.apiEndpoint + 'TimeSlot/Get')
            .map((response: Response) => response.json());
    }

    getAvailable(truckSize: string, etaDateString: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('truckSize', truckSize);
        params.set('etaDateString', etaDateString);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'TimeSlot/GetAvailable', options)
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/op/time-slot.service.ts